<template>
  <v-container id="signUp" fill-height="fill-height" fluid style="overflow=hidden">
    <v-layout
      class="text-center"
      align-center="align-center"
      justify-center
      row
      fill-height="fill-height"
    >
      <v-flex xs12 md4 lg2="lg2">
        <v-card min-width="300">
          <v-card-text>
            <v-container class="pa-0" grid-list-md="grid-list-md">
              <h2 class="mt-2 headline">
                <span class="deep-orange--text font-weight-bold">Cell</span>
                <span class="deep-orange--text">Smart</span>
                <span class="ml-1">{{ $t("pageHeader.portal") }}</span>
              </h2>
              <h2 class="mt-4 title font-weight-light">Create Account</h2>
              <v-layout class="mt-2" wrap>
                <v-flex xs6="xs6">
                  <v-text-field
                    outlined
                    dense
                    :error-messages="firstNameErrors"
                    :label="$t('labels.firstName')"
                    v-model.trim="user.firstName"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs6="xs6">
                  <v-text-field
                    outlined
                    dense
                    :label="$t('labels.lastName')"
                    :error-messages="lastNameErrors"
                    v-model.trim="user.lastName"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    outlined
                    dense
                    v-model="user.loginEmail"
                    :error-messages="emailErrors"
                    :label="$t('labels.email')"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    outlined
                    dense
                    v-model="user.loginPassword"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    :label="$t('labels.password')"
                    v-on:keyup.enter="submit"
                    :error-messages="passwordErrors"
                    @input="$v.user.loginPassword.$touch()"
                    counter="counter"
                    @click:append="showPassword = !showPassword"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="mt-1" row align-center="align-center">
                <v-btn color="orange" dark="dark" block="block" rounded @click="submit"
                  >Sign Up</v-btn
                >
              </v-layout>
              <!-- <h2 class="mt-2 body-2 font-weight-light">or Sing up with</h2> -->
              <!-- <GoogleSignUp class="pointer" v-on:response="checkResponse"> </GoogleSignUp> -->
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-card width="100%" color="grey lighten-2">
              <v-card-text>
                <v-layout
                  align-center="align-center"
                  justify-center
                  column
                  fill-height="fill-height"
                >
                  <h2 class="body-1 font-weight-light">
                    Already have an account?<a class="ml-1" @click="login">Login</a>
                  </h2>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import signUpService from "./service.js";
import GoogleSignUp from "../Authentication/components/GoogleSignUp";
const { validationMixin } = require("vuelidate");
const { required, minLength, email } = require("vuelidate/lib/validators");

export default {
  name: "signUp",
  data() {
    return {
      showPassword: false,
      user: {
        firstName: null,
        lastName: null,
        loginEmail: null,
        loginPassword: null
      },
      signUpSuccess: false
    };
  },
  methods: {
    checkResponse(response) {
      if (response.status === 400) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: "Invalid User"
          });
      } else {
        this.$router.push({ path: "/" });
      }
    },
    login() {
      this.$router.push({ path: "/login" });
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.user.fullName = `${this.user.firstName} ${this.user.lastName}`;
        this.user.userName = `${this.user.firstName} ${this.user.lastName}`;
        this.user.userType = 2;
        this.user.accountTypeID = 7;
        signUpService
          .submit(this.user)
          .then(response => {
            console.log("response", response);
            this.$router.push({ path: "/login?loginEmail=" + this.user.loginEmail });
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Account Was Created!"
              });
          })
          .catch(error => {
            console.log("test", error);
            this.$swal({
              title: "Sign Up",
              text: error.data.data,
              type: "info",
              allowOutsideClick: false,
              showCancelButton: true,
              confirmButtonText: "Try Login"
            }).then(result => {
              console.log("result", result);
              if (result.value) {
                this.$router.push({ path: "/login?loginEmail=" + this.user.loginEmail });
              }
            });
          });
      }
    }
  },
  components: {
    GoogleSignUp
  },
  computed: {
    firstNameErrors() {
      const errors = [];
      if (!this.$v.user.firstName.$dirty) return errors;
      if (!this.$v.user.firstName.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.user.firstName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast2ChrLong"));
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.user.lastName.$dirty) return errors;
      if (!this.$v.user.lastName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast2ChrLong"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.user.loginEmail.$dirty) return errors;
      if (!this.$v.user.loginEmail.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.user.loginEmail.email) errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.user.loginPassword.$dirty) return errors;
      if (!this.$v.user.loginPassword.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.user.loginPassword.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    }
  },
  mixins: [validationMixin],
  validations: {
    user: {
      firstName: {
        required,
        minLength: minLength(2)
      },
      lastName: {
        minLength: minLength(1)
      },
      loginEmail: {
        email,
        required
      },
      loginPassword: {
        required,
        minLength: minLength(4)
      }
    }
  }
};
</script>
<style scoped>
#signUp {
  /* background-image:url(https://picsum.photos/1200/?random&blur); */
  background-image: url(http://backgrounddownload.com/wp-content/uploads/2018/09/cool-orange-background-designs-7.jpg);
  background-size: cover;
}
</style>
